import { Plus } from 'lucide-react'
import { Button } from '@trafiflow/shared-ui'
import { RuleCard } from './RuleCard'
import { EmptyState } from '../shared/EmptyState'
import { useFunnelRules } from '../../hooks'
import type { FunnelRule } from '../../types'

interface RuleListProps {
  funnelId?: string
  initialRules?: FunnelRule[]
  onRulesChange?: (rules: FunnelRule[]) => void
}

export function RuleList({ funnelId, initialRules = [], onRulesChange }: RuleListProps) {
  const {
    rules,
    addRule,
    updateRule,
    deleteRule,
    addTrigger,
    updateTrigger,
    deleteTrigger,
    addAction,
    updateAction,
    deleteAction,
  } = useFunnelRules(funnelId, initialRules)

  const handleAddRule = () => {
    addRule()
    onRulesChange?.(rules)
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-fn-text">
            Rules
          </h3>
          <p className="text-xs text-fn-text-muted">
            Define targeting rules for this step
          </p>
        </div>
        <Button variant="primary" className="text-sm" onClick={handleAddRule}>
          <Plus className="w-4 h-4 mr-1" /> Add Rule
        </Button>
      </div>

      {rules.length === 0 ? (
        <EmptyState
          icon={<Plus className="w-6 h-6 text-fn-text-muted" />}
          title="No rules defined"
          description="Add rules to control when this step is shown"
          actionLabel="Add First Rule"
          onAction={handleAddRule}
        />
      ) : (
        <div className="space-y-2">
          {rules.map((rule) => (
            <div key={rule.id} className="animate-fade-slide-in">
            <RuleCard
              rule={rule}
              onUpdate={(updates) => updateRule(rule.id, updates)}
              onDelete={() => deleteRule(rule.id)}
              onAddTrigger={() => addTrigger(rule.id)}
              onUpdateTrigger={(triggerId, updates) => updateTrigger(rule.id, triggerId, updates)}
              onDeleteTrigger={(triggerId) => deleteTrigger(rule.id, triggerId)}
              onAddAction={() => addAction(rule.id)}
              onUpdateAction={(actionId, updates) => updateAction(rule.id, actionId, updates)}
              onDeleteAction={(actionId) => deleteAction(rule.id, actionId)}
            />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
